export default __webpack_public_path__ + "static/media/banner.fbf7e024.jpg";